import { defineMessages } from 'react-intl';

export const messages: {
	connected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	retry: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	new: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	checkIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalLinkIconlabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorizationSuccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorizationFail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	connected: {
		id: 'product-tile-connected',
		defaultMessage: 'Connected',
		description: 'Text displayed when a product is connected',
	},
	failed: {
		id: 'product-tile-failed',
		defaultMessage: 'Failed.',
		description: 'Error text displayed when a product does has failed to connect',
	},
	retry: {
		id: 'product-tile-try-again',
		defaultMessage: 'Try again',
		description: 'Text displayed when a user is prompted to retry connection',
	},
	connect: {
		id: 'product-tile-connect',
		defaultMessage: 'Connect',
		description: 'Text displayed when a user is prompted to connect',
	},
	new: {
		id: 'product-tile-new',
		defaultMessage: 'New',
		description:
			'Badge text shown on a product tile in the bulk connect dialog to highlight that the product was recently added.',
	},
	checkIconLabel: {
		id: 'product-tile-check-icon-label',
		defaultMessage: 'Check Icon',
		description:
			'Accessible label for the check icon on a product tile indicating the product is successfully connected.',
	},
	errorIconLabel: {
		id: 'product-tile-error-icon-label',
		defaultMessage: 'Error Icon',
		description:
			'Accessible label for the error icon on a product tile indicating a connection failure.',
	},
	externalLinkIconlabel: {
		id: 'product-tile-external-link-icon-label',
		defaultMessage: 'External Link Icon',
		description:
			'Accessible label for the external link icon on a product tile that navigates the user to the third-party app authorization page.',
	},
	authorizationSuccess: {
		id: 'product-tile-oauth-warning.authorization-success',
		defaultMessage: 'Successfully connected to {product}',
		description: 'Message displayed when authorization is successful.',
	},
	authorizationFail: {
		id: 'product-tile-oauth-warning.authorization-fail',
		defaultMessage: 'Failed to connect to {product}',
		description: 'Message displayed when authorization fails',
	},
});
